// dealer retailer registration
export const stallPartRegistrationList = '/event-management/registration-list/list'
export const rejectRgistration = '/event-management/registration-list/reject'
export const stallRegistrationForward = '/event-management/registration-list/forward'
export const recommendedList = '/event-management/recommended-list/list'
export const stallApproveList = '/event-management/approved-list/list'
export const stallApprove = '/event-management/approved-list/approve'
// Direct Assign Store Api Routes....
export const direactAssignList = '/event-management/direct-assign-stall/list'
export const direactAssignStore = '/event-management/direct-assign-stall/store'
export const direactAssignUpdate = '/event-management/direct-assign-stall/update'
export const assignStallUpdate = '/event-management/direct-assign-stall/assign-stall'
export const assignStallStatus = '/event-management/direct-assign-stall/stall-status'

// Year Wise Evaluation Criteria Api Routes....
export const criteriaDataList = '/event-management/year-wise-evaluation-criteria/criteria-data'
export const fairEvaluationStore = '/event-management/year-wise-evaluation-criteria/store'
export const fairEvaluationList = '/event-management/year-wise-evaluation-criteria/list'
export const fairEvaluationUpdate = '/event-management/year-wise-evaluation-criteria/update'
export const EvaluationStatus = '/event-management/year-wise-evaluation-criteria/stall-status'
export const registrationWiseProfileList = '/event-management/direct-assign-stall/stall-profile'
export const directAssignStallShow = '/event-management/direct-assign-stall/show'

// Fair Evaluation List Api Routes....
export const fairEvaluationListData = '/event-management/fair-evaluation-list/list'
export const fairEvaluationCriteriaData = '/event-management/fair-evaluation-list/criteria-data'
export const fairEvaluationStoreData = '/event-management/fair-evaluation-list/store'

// Event Management stall Status Report Api Route
export const stallStatusReport = '/event-management/reports/stall-status-report'
export const reportHeadingList = '/configuration/report-heading/detail'
export const stallParticipantCertificate = 'stall-participant/certificate'
export const stallParticipantCertificateDataList = stallParticipantCertificate + '/datalist'
export const eventSummaryApi = '/event-management/reports/event-summary-report'
export const reportHeadingListNew = 'configuration/report-heading/listnew'
export const stallParticipantCertificateData = stallParticipantCertificate + '/data'

// Stall Assign Status Report
export const stallAssignStatusReport = '/event-management/reports/stall-assign-report'

// Stall Participant routes
export const stallParticipantProfileStore = '/event-management/approved-list/participant-store'
export const stallParticipantProfileShow = '/event-management/approved-list/participant-show'
export const stallParticipantProfileUpdate = '/event-management/approved-list/participant-update'
